"use strict";
/**
 * NOTE:
 * This configuration is used when Alloy is initialized by the application
 * using createInstance (initAlloy.ts).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOY_AMPCOM_CONFIG = void 0;
exports.ALLOY_AMPCOM_CONFIG = {
    datastreamId: '8fc9f868-7a85-4db9-ae11-3e473488cb3c',
    orgId: 'B1B3678254F600AD0A4C98A5@AdobeOrg',
    debugEnabled: true,
    defaultConsent: 'in'
};
